<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">call</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.whatsapp' | translate}}</span>
      </div>
      <!-- / APP TITLE -->
      <!--<button mat-raised-button-->
      <!--(click)="newPicture()"-->
      <!--class="add-product-button mat-white-bg my-12 mt-sm-0">-->
      <!--<span>{{'picture.add_new_picture' | translate}}</span>-->
    <!--</button>-->

  </div>
  <!-- / HEADER -->
  <!-- CONTENT CARD -->
  <div class="content-card mat-white-bg">
    <!-- / SEARCH -->
    @if (dataSource) {
      <div class="column has-text-centered">
        <table mat-table [dataSource]="dataSource" class="products-table"
          matSort (matSortChange)="sortData($event)">
          <ng-container matColumnDef="organization">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="organization"> {{'user.organization' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>
          <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              @if (element.logo) {
                <img class="product-image"
                  [alt]="element.name"
                  [src]="getImage(element.logo)"/>
              }
              @if (!element.logo) {
                <img class="product-image" [src]="'assets/images/organization_black.svg'">
              }</td>
            </ng-container>
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="user"> {{'main.frontuser' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.firstName}} {{element.lastName}} </td>
            </ng-container>
            <ng-container matColumnDef="count">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="count" > {{'number_of_messages' | translate}} </th>
              <td mat-cell *matCellDef="let element" > {{element.count}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      }
      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 20]"
        [pageIndex]="pageIndex"
        [length]="totalCount"
        (page)="changePageEmitter($event)"
      showFirstLastButtons></mat-paginator>
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
